import { render } from "./LocatorListView.vue?vue&type=template&id=d32ff7e0&ts=true"
import script from "./LocatorListView.vue?vue&type=script&lang=ts"
export * from "./LocatorListView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__